import instance from '~/config/apiAxiosInstance';

export default function request(payload) {
  switch (payload.method) {
    default:
      return Promise.reject(new Error('Unknown API method'));
    case 'GET':
      return instance.get(payload.url, payload);
    case 'POST':
      return instance.post(payload.url, payload.body, payload);
    case 'PUT':
      return instance.put(payload.url, payload.body, payload);
    case 'PATCH':
      return instance.patch(payload.url, payload.body, payload);
    case 'DELETE':
      return instance.delete(payload.url, payload);
  }
}
